import type {
  CardQuality,
  GameplayTier,
} from '@sorare/core/src/__generated__/globalTypes';
import { GameplayTierStars } from '@sorare/core/src/components/card/GameplayTierStars';
import { CardQualityStars } from '@sorare/core/src/components/card/StarRank';
import type { Unit } from '@sorare/core/src/lib/style';

type Props = {
  quality: Nullable<CardQuality>;
  gameplayTier: Nullable<GameplayTier>;
  size?: Unit;
};

// Renders the tier on a CardPull card or pull. Per the backend invariant,
// at most one of `quality` / `gameplayTier` is populated — this picks
// whichever is present.
export const PulledCardStars = ({ quality, gameplayTier, size }: Props) => {
  if (gameplayTier) {
    return <GameplayTierStars gameplayTier={gameplayTier} size={size} />;
  }
  if (quality) {
    return <CardQualityStars cardQuality={quality} size={size} />;
  }
  return null;
};
